import { render, staticRenderFns } from "./BookmarkDetail.vue?vue&type=template&id=cc5307f0&scoped=true&lang=pug&"
import script from "./BookmarkDetail.vue?vue&type=script&lang=ts&"
export * from "./BookmarkDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkDetail.vue?vue&type=style&index=0&id=cc5307f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5307f0",
  null
  
)

export default component.exports